import { render, staticRenderFns } from "./CandidatesTabs.vue?vue&type=template&id=00f2b5bf&scoped=true"
import script from "./CandidatesTabs.vue?vue&type=script&lang=js"
export * from "./CandidatesTabs.vue?vue&type=script&lang=js"
import style0 from "./CandidatesTabs.vue?vue&type=style&index=0&id=00f2b5bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2b5bf",
  null
  
)

export default component.exports